// utils/embedTracking.ts — Aturan pixel di dalam iframe embed (anti double-count).
// LP induk (Berdu/dll) sudah menghitung kunjungan (PageView + ViewContent) dengan
// pixel yang SAMA → iframe wajib tidak mengulang event top-funnel yang sama.
// Sepenuhnya konfigurasi per-form (trackingSettings.embedTracking.mode), tanpa hardcode.

export type EmbedTrackingMode = 'smart' | 'full' | 'none';

const VALID_MODES: EmbedTrackingMode[] = ['smart', 'full', 'none'];

// Halaman dibuka di dalam <iframe>? Aman cross-origin (tanpa baca properti parent).
export function isEmbedded(): boolean {
    try {
        return window.self !== window.top;
    } catch {
        return true;
    }
}

// Default 'smart' bila form lama belum punya setting (tanpa migrasi DB).
export function resolveEmbedTrackingMode(trackingSettings?: any): EmbedTrackingMode {
    const m = trackingSettings?.embedTracking?.mode;
    return (VALID_MODES as string[]).includes(m) ? (m as EmbedTrackingMode) : 'smart';
}

// Event top-funnel (kunjungan/lihat) — dinormalisasi lintas platform:
// PageView, page_view, ViewContent, view_content, view_item.
const TOP_FUNNEL = new Set(['pageview', 'viewcontent', 'viewitem']);
export function isTopFunnelEvent(eventName?: string): boolean {
    if (!eventName) return false;
    return TOP_FUNNEL.has(eventName.toLowerCase().replace(/[^a-z]/g, ''));
}

// Keputusan skip per event: standalone selalu fire; 'full' selalu fire;
// 'none' + embedded = skip semua; 'smart' + embedded = skip top-funnel saja
// (konversi InitiateCheckout/Lead/Purchase tetap jalan + CAPI).
export function shouldSkipEvent(opts: { embedded: boolean; mode: EmbedTrackingMode; eventName?: string }): boolean {
    if (!opts.embedded) return false;
    if (opts.mode === 'none') return true;
    if (opts.mode === 'smart') return isTopFunnelEvent(opts.eventName);
    return false;
}

// Closure skip + log sekali tulis — dipakai semua fire func platform.
export function makeEmbedSkipper(embedded: boolean, mode: EmbedTrackingMode, logPrefix: string) {
    return (platform: string, eventName?: string): boolean => {
        const skip = shouldSkipEvent({ embedded, mode, eventName });
        if (skip) console.log(`[${logPrefix} ${platform}] ${eventName} skipped (embedded, mode=${mode})`);
        return skip;
    };
}
